import React from "react";
import { faListCheck } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Button } from "../shared/Button/Button";
import {
  SuccessContainer,
  IconContainer,
  StyledIcon,
  Title,
  Subtitle,
  ButtonContainer,
} from "./SuccessMessage.styles";

interface IntermediateSuccessMessageProps {
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

export const IntermediateSuccessMessage: React.FC<
  IntermediateSuccessMessageProps
> = ({
  onPrimaryAction,
  onSecondaryAction,
  primaryButtonText,
  secondaryButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <SuccessContainer>
      <IconContainer>
        <StyledIcon icon={faListCheck} $iconColor="#017E72" />
      </IconContainer>

      <Title>{t("missingBillingInformation.intermediate.title")}</Title>
      <Subtitle>
        {t("missingBillingInformation.intermediate.subtitle")}
      </Subtitle>

      <ButtonContainer>
        <Button
          label={
            primaryButtonText ||
            t("missingBillingInformation.actions.updateAddress")
          }
          data-testid="primary-action-button"
          onClick={onPrimaryAction}
          fullWidth
          size="medium"
          backgroundColor="greenDark"
        />
        <Button
          label={
            secondaryButtonText || t("missingBillingInformation.actions.notNow")
          }
          data-testid="secondary-action-button"
          onClick={onSecondaryAction || (() => {})}
          fullWidth
          size="medium"
          reverse
          backgroundColor="greenDark"
        />
      </ButtonContainer>
    </SuccessContainer>
  );
};
